import { Button, Card, Col, Input, Pagination, Row, Spin, Table, message, Tooltip, App, Modal } from 'antd'
import { EyeFilled, LoadingOutlined, DeleteOutlined, PlusOutlined, FileExclamationOutlined, ArrowUpOutlined, MailOutlined, BarChartOutlined, EditFilled, EyeOutlined } from "@ant-design/icons";
import React, { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { LIST_LANDING_PAGE, DELETE_LANDING, VIEW_LANDING } from '../../apis/apis';
import debounce from 'lodash.debounce';
import CulsightPageLoader from '../../components/CulsightPageLoader';
import LandingPageCard from './LandingPageCard';
import DOMPurify from "dompurify";

function LandingPage() {
  // STATES
  const { message, modal } = App.useApp();
  const navigate = useNavigate();
  const [loader, setLoader] = useState(true);
  const [pagination_loader, set_pagination_loader] = useState(false);
  const [table_data, set_table_data] = useState(false);
  const [current_page, set_current_page] = useState(
    Number(localStorage.getItem("landing_page")) || 1
  );
  const [total_pages, set_total_pages] = useState("");
  const [total_landing_page, set_total_landing_page] = useState("");
  const [search_query_name, set_search_query_name] = useState(
    localStorage.getItem("landing_search") || ""
  );

  const [previewModal, setPreviewModal] = useState(false);
  const [previewLoader, setPreviewLoader] = useState(false);
  const [previewHtml, setPreviewHtml] = useState("");
  const [previewName, setPreviewName] = useState("");



  // LIST API
  const LIST_API = async (
    page = current_page,
    search = search_query_name
  ) => {

    const FORM_DATA = new FormData();

    FORM_DATA.append("page", page);

    if (search) {
      FORM_DATA.append("name", search);
    }

    const API_CALL = await LIST_LANDING_PAGE(FORM_DATA);

    if (API_CALL?.data?.status) {
      set_table_data(API_CALL?.data?.data || []);
      set_current_page(API_CALL?.data?.current_page);
      set_total_pages(API_CALL?.data?.total_pages);
      set_total_landing_page(API_CALL?.data?.total_landing_page);
    }

    setLoader(false);
    set_pagination_loader(false);
  };

  useEffect(() => {
    LIST_API(
      Number(localStorage.getItem("landing_page")) || 1,
      localStorage.getItem("landing_search") || ""
    );
  }, []);


  // SEARCH API 
  const fetchResultsName = useCallback((value) => {
    debounce(async () => {
      try {
        set_search_query_name(value);
        set_pagination_loader(true);

        const FORM_DATA = new FormData();

        FORM_DATA.append("page", 1); // add
        FORM_DATA.append("name", value);

        const API_CALL = await LIST_LANDING_PAGE(FORM_DATA);

        if (API_CALL?.data?.status) {
          set_table_data(API_CALL.data?.data);

          set_current_page(1); // add
          localStorage.setItem("landing_page", 1); // add

          set_total_pages(API_CALL?.data?.total_pages);
          set_total_landing_page(API_CALL.data?.total_landing_page);
        }

        set_pagination_loader(false);
      } catch (err) {
        console.error("API Error:", err);
      }
    }, 500)();
  }, []);


  // SEARCH INPUT
  const handleInput = (e) => {
    const value = e.target.value;

    if (value && !search_query_name) {
      localStorage.setItem(
        "landing_last_search_page",
        current_page
      );
    }

    set_search_query_name(value);

    localStorage.setItem(
      "landing_search",
      value
    );

    clearTimeout(window.landingSearchTimer);

    window.landingSearchTimer = setTimeout(() => {

      const pageToLoad = value
        ? 1
        : Number(
          localStorage.getItem(
            "landing_last_search_page"
          )
        ) || 1;

      set_current_page(pageToLoad);

      LIST_API(
        pageToLoad,
        value
      );

    }, 500);
  };


  // PAGINATION API 
  const pagination_on_change = async (page) => {

    localStorage.setItem(
      "landing_page",
      page
    );

    set_pagination_loader(true);

    LIST_API(
      page,
      search_query_name
    );
  };

  const handleDelete = (id) => {
    modal.confirm({
      title: "Are you sure want to delete?",
      onOk: async () => {
        const FORM_DATA = new FormData();
        FORM_DATA.append("id", id);

        const response = await DELETE_LANDING(FORM_DATA);
        if (response?.data?.status) {
          message.success("Deleted Successfully");
          LIST_API();
        } else {
          message.error("Failed to delete");
        }
      }
    });
  };

  const handlePreview = async (id) => {
    setPreviewLoader(true);
    setPreviewModal(true);

    const FORM_DATA = new FormData();
    FORM_DATA.append("id", id);

    const API = await VIEW_LANDING(FORM_DATA);

    if (API?.data?.status) {
      const data = API?.data?.data;

      setPreviewName(data?.name);
      setPreviewHtml(data?.description || "<h3>No Preview Available</h3>");
    }

    setPreviewLoader(false);
  };


  // TABLE COLUMNS
  const columns = [
    {
      title: "Landing Page Name",
      dataIndex: "name",
      render: (text, record) => (
        <span>
          {record.name}
        </span>
      ),
    },
    {
      title: "User Count",
      render: (text, record) => (
        <span>
          {record.landing_page_count}
        </span>
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <>
          <Tooltip title="Edit">
            <EditFilled
              style={{
                color: "#8c3add",
                cursor: "pointer",
                fontSize: "18px"
              }}
              onClick={() =>
                navigate("/edit-landingpage/" + btoa(record.id))
              }
            />
          </Tooltip>

          <Tooltip title="Preview">
            <EyeOutlined
              style={{
                color: "#8c3add",
                cursor: "pointer",
                fontSize: "18px"
              }}
              onClick={() => handlePreview(record.id)}
            />
          </Tooltip>

          <Tooltip title="Delete">
            <Button
              style={{ marginRight: 12 }}
              variant="solid"
              color="danger"
              size="small"
              onClick={() => handleDelete(record.id)}
            >
              <DeleteOutlined />
            </Button>

          </Tooltip>

        </>
      ),

    },
  ];


  return (
    <div className='lms-body'>

      <Row>
        <Col span={12}>
          <h1 style={{ margin: "0px", padding: "0px" }}>Landing Page</h1>
          <span style={{ color: "gray", fontSize: "16px", fontWeight: "600" }}>Manage phishing landing pages for simulations</span>
        </Col>
        <Col span={12}>
          <Button size='large' type='primary' style={{ marginLeft: "10px", float: "right" }} onClick={() => {

            localStorage.setItem(
              "landing_page",
              current_page
            );

            localStorage.setItem(
              "landing_search",
              search_query_name
            );

            navigate("/add-landingpage");
          }}
          >
            <PlusOutlined /> Add Landing Page</Button>
        </Col>
      </Row>

      <Row gutter={[20, 20]} style={{ marginTop: "20px" }}>

        <Col xs={24} >
          <Card
            hoverable
            style={{
              borderRadius: 16,
              height: 80,
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <div
                style={{
                  background: "#ede9fe",
                  padding: "10px",
                  borderRadius: "12px",
                  marginTop: "-20px"
                }}
              >
                <BarChartOutlined style={{ color: "#8c3add", fontSize: 18 }} />
              </div>

              <div style={{ marginTop: "-10px" }}>
                <h2 style={{ margin: 0 }}>{total_landing_page}</h2>
                <span style={{ color: "gray", fontSize: "13px" }}>
                  Total Pages
                </span>
              </div>
            </div>


          </Card>
        </Col>






      </Row>

      <Card style={{ marginTop: "10px" }}>
        <Row>
          <Col span={20}>
            <Input
              addonBefore={<span>Name</span>}
              placeholder="Search here"
              value={search_query_name}
              onChange={handleInput}
              size="large"
            />
          </Col>

        </Row>

        {loader ? (
          <>
            <CulsightPageLoader />
          </>
        ) : (
          <>
            {pagination_loader ? (
              <>
                <div style={{ textAlign: "center", padding: "60px" }}>
                  <Spin indicator={<LoadingOutlined spin />} size="large" />
                </div>
              </>
            ) : (
              <>
                <Row gutter={[16, 16]} style={{ marginTop: "15px" }}>
                  {table_data?.map((item) => (
                    <Col xs={24} sm={12} md={8} lg={8} key={item.id}>
                      <LandingPageCard data={item} current_page={current_page} search_query_name={search_query_name} onDelete={handleDelete} onPreview={handlePreview}
                      />
                    </Col>
                  ))}
                </Row>
              </>
            )}

            {total_pages > 0 ? (
              <>
                <div style={{ float: "right", marginTop: "20px" }}>
                  {" "}
                  <Pagination
                    onChange={pagination_on_change}
                    current={current_page}
                    total={total_landing_page}
                    showSizeChanger={false}
                  />
                </div>
              </>
            ) : (
              <>

              </>
            )}
          </>
        )}
      </Card>
      <Modal
        title={`Preview - ${previewName}`}
        open={previewModal}
        onCancel={() => setPreviewModal(false)}
        footer={null}
        width={900}
      >
        {previewLoader ? (
          <div style={{ textAlign: "center", padding: "20px" }}>
            <Spin
              indicator={<LoadingOutlined spin />}
              size="large"
            />
          </div>
        ) : (
          <div
            style={{
              maxHeight: "70vh",
              overflowY: "auto",
              padding: "20px",
            }}
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(previewHtml),
            }}
          />
        )}
      </Modal>
    </div>
  )
}

export default LandingPage
